var map = {
	"./symbol_0.png": 49176,
	"./symbol_1.png": 70305,
	"./symbol_10.png": 95957,
	"./symbol_11.png": 26860,
	"./symbol_2.png": 39722,
	"./symbol_3.png": 94931,
	"./symbol_4.png": 40060,
	"./symbol_5.png": 6597,
	"./symbol_6.png": 52590,
	"./symbol_7.png": 81815,
	"./symbol_8.png": 78256,
	"./symbol_9.png": 68153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45515;